module.exports = __webpack_public_path__ + "img/management.56308002.png";